import React from 'react';
import { LexicalEditor, $getRoot, $isElementNode } from 'lexical';
import { Icons } from '@mutiny-pkg/dumpster-ui/icons';
import { IconButton } from '@mutiny-pkg/dumpster-ui/components/Button';
import * as styles from './FloatingMenu.css';

export const TextAlignButton = React.forwardRef<
  HTMLButtonElement,
  { editor: LexicalEditor; align: 'left' | 'center' | 'right' }
>(({ editor, align }, ref) => {
  const alignLabel = align.charAt(0).toUpperCase() + align.slice(1);

  return (
    <IconButton
      ref={ref}
      tabIndex={-1}
      className={styles.toolbarButton({ active: editor.read(() => $getRoot().getFormatType()) === align })}
      label={`${alignLabel} align`}
      icon={Icons[`TextAlign${alignLabel}` as keyof typeof Icons]}
      variant="text"
      onMouseDown={(event) => {
        event.preventDefault();
        editor.update(() => {
          $getRoot().setFormat(align);
          $getRoot()
            .getChildren()
            .forEach((child) => {
              if ($isElementNode(child)) {
                child.setFormat(align);
              }
            });
        });
      }}
    />
  );
});

TextAlignButton.displayName = 'TextAlignButton';
